import React, { useEffect, useState } from "react";
import styles from "./ViewCdha.module.css";
import {
    Card,
    Col,
    Collapse,
    Row,
    Typography,
} from "antd";
import ReactImageGallery from "react-image-gallery";
import "react-image-gallery/styles/css/image-gallery.css";
import { useLocation } from "react-router-dom";
import PatientInfo from "../../components/common/PatientInfo/PatientInfo";
import Loading from "../../components/common/Loading/Loading";
import { PACSViewerSection } from "../../components/ViewCdha/ViewCdha";
import Label from "../../components/common/Label/Label";
import {
    FaQrcode,
    FaExternalLinkAlt,
    FaFilePdf,
    FaImages,
    FaCalendarAlt,
    FaNotesMedical
} from "react-icons/fa";
import { cdhaService } from "../../services/cdhaService";
const { Title, Text } = Typography;
const { Panel } = Collapse;



const ViewCdha = () => {
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState(null);
    const { search } = useLocation();
    const externId = new URLSearchParams(search).get("id");

    useEffect(() => {
        const fetchData = async () => {
            try {
                const res = await fetch(
                    `${process.env.REACT_APP_CRM_ENDPOINT_URL}/en/api/v1.0/KetQuaCdha/cdha/${process.env.REACT_APP_SECRETKEY}?id=${externId}`
                );
                const json = await res.json();
                setData(json.data);
            } catch (error) {
                console.error("Lỗi fetch:", error);
            } finally {
                setLoading(false);
            }
        };

        if (externId) {
            fetchData();
        } else {
            setLoading(false);
        }
    }, [externId]);

    if (loading) {
        return <Loading tip="Đang tải dữ liệu..." fullScreen={true} />;
    }

    if (!data) {
        return (
            <div style={{ textAlign: "center", paddingTop: 100 }}>
                <Title level={3}>Không tìm thấy dữ liệu</Title>
            </div>
        );
    }

    const isPdf = (url) => url.toLowerCase().endsWith(".pdf");

    const {
        tenDichVu,
        ngayKQ,
        moTa,
        ketLuan,
        typeCls,
        urls = [],
        pacsUrl = "",
    } = data;
    const galleryItems = cdhaService.formatGalleryItems(urls);

    return (
        <Row justify="center" style={{ padding: "16px 0 0" }}>
            <Col xs={24} sm={22} md={20} lg={16} xl={14}>
                <div className={styles.wrapSelectSection}>
                    {/* Thông tin bệnh nhân */}
                    <PatientInfo
                        data={data}
                    />
                    {/* Thông tin dịch vụ */}
                    <div className={styles.selectSection}>
                        <Label>
                            Dịch vụ: {tenDichVu}
                        </Label>
                        <div className={styles.serviceCard}>
                            <div className={styles.serviceInfo}>
                                <div className={styles.infoRow}>
                                    <span className={styles.infoLabel}>
                                        <FaCalendarAlt className={styles.infoIcon} />
                                        Ngày có kết quả:
                                    </span>
                                    <span className={styles.resultDateBadge}>{ngayKQ}</span>
                                </div>
                            </div>
                            <Collapse
                                ghost
                                defaultActiveKey={["1", "2"]}
                                expandIconPosition="end"
                            >
                                {moTa && (
                                    <Panel
                                        header={<span><FaNotesMedical className={styles.panelIcon} /> Mô tả chi tiết</span>}
                                        key="1"
                                        style={{ fontWeight: "bold" }}
                                    >
                                        <Text
                                            style={{ whiteSpace: "pre-wrap", fontWeight: "normal" }}
                                        >
                                            {moTa}
                                        </Text>
                                    </Panel>
                                )}
                                <Panel
                                    header={
                                        <span><FaNotesMedical className={styles.panelIcon} /> {cdhaService.getPanelTitle(typeCls)}</span>
                                    }
                                    key="2"
                                    style={{ fontWeight: "bold" }}
                                >
                                    <Text style={{ whiteSpace: "pre-wrap", fontWeight: "normal" }}>
                                        {ketLuan}
                                    </Text>
                                </Panel>
                            </Collapse>
                        </div>

                    </div>



                    {/* Hình ảnh liên quan */}
                    {Array.isArray(urls) && urls.length > 0 && (
                        <div className={styles.selectSection}>
                            <Label>
                                Hình ảnh liên quan
                            </Label>
                            <div className={styles.serviceCard}>
                                <ReactImageGallery
                                    items={galleryItems.map((item) => {
                                        if (item.isPdf) {
                                            return {
                                                original: item.original,
                                                thumbnail: item.thumbnail,
                                                description: item.description,
                                                renderItem: () => (
                                                    <div
                                                        className={styles.pdfPlaceholder}
                                                        onClick={() => window.open(item.pdfUrl, "_blank")}
                                                    >
                                                        <FaFilePdf className={styles.pdfIcon} />
                                                        <span className={styles.pdfText}>📄 Nhấn để mở file PDF</span>
                                                    </div>
                                                )
                                            };
                                        }
                                        return {
                                            original: item.original,
                                            thumbnail: item.thumbnail,
                                            description: item.description
                                        };
                                    })}
                                    showThumbnails
                                    showPlayButton={false}
                                    showFullscreenButton
                                    lazyLoad
                                />
                            </div>
                        </div>
                    )}

                    {/* PACS Viewer */}
                    {pacsUrl && <PACSViewerSection pacsUrl={pacsUrl} />}
                </div>

            </Col>
        </Row>
    );
};

export default ViewCdha;
